import React from 'react'
import { useSelector } from 'react-redux'
import { IntlProvider } from 'react-intl'
import LOCALES from '../locales'
import { RootState } from '../types/rootState'
import { Locale } from '../types/locale'

interface CustomIntlProviderProps {
  children: React.ReactNode
}

export const CustomIntlProvider = (props: CustomIntlProviderProps) => {
  const locale = useSelector<RootState, Locale>(state => state.locale)
  const localeString = locale?.locale ?? 'en'
  const messages = LOCALES[localeString.slice(0, 2)]
  const children = props.children

  return (
    <IntlProvider locale={localeString} key={localeString} messages={messages}>
      {children}
    </IntlProvider>
  )
}
